<script lang="ts">
	import { selectedClientStore } from '../../../../api/EnzianDataApi';
	import IconButton from '../../../../basic/buttons/IconButton.svelte';
	import DefaultSimpleList from '../../../../basic/list/DefaultSimpleList.svelte';
	import Searchbar from '../../../../basic/search/Searchbar.svelte';
	import { createSettingDocumentNameGeneratorStore } from '../../../../stores/SettingDocumentNameGeneratorsStore.svelte';
	import { type SettingDocumentNameGenerator } from '../../../../types/BasicTypes';
	import { onDestroy } from 'svelte';
	import { _ } from 'svelte-i18n';
	import CreateSettingDocumentNameGenerator from './CreateSettingDocumentNameGenerator.svelte';
	import ListItemSettingDocumentNameGenerator from './ListItemSettingDocumentNameGenerator.svelte';
	import PatchSettingDocumentNameGenerator from './PatchSettingDocumentNameGenerator.svelte';

	interface Props {
		showDetailOnClick?: boolean;
		onSelectionChanged?: (item: SettingDocumentNameGenerator) => void;
	}

	let { showDetailOnClick = true, onSelectionChanged }: Props = $props();

	let showCreateModal: boolean = $state(false);
	let targetSettingNameGenerator: SettingDocumentNameGenerator | undefined = $state();

	let settingDocumentNameGeneratorStore = $state(createSettingDocumentNameGeneratorStore());

	//Add reactivity for client change
	let unSubscribe = selectedClientStore.subscribe((client) => {
		if (client == null) return;

		settingDocumentNameGeneratorStore.applyFilter();
	});

	onDestroy(() => {
		unSubscribe();
	});
</script>

<div class="h-full overflow-y-auto pt-8">
	<!--Add the list of document types-->
	<div class="h-full grid grid-rows-[auto_1fr]">
		<div class="items-center flex pb-9 pl-8 gap-8">
			<Searchbar
				onSearchTrigger={() => {
					settingDocumentNameGeneratorStore.applyFilter();
				}}
				placeholder={$_('settings.basic.document_name_generators.lbl_hint')}
				bind:filter={settingDocumentNameGeneratorStore.listFilter}
			/>
			<IconButton
				iconName="plus"
				hoverText={$_('settings.basic.document_name_generators.lbl_add')}
				primary={true}
				onClick={() => {
					showCreateModal = true;
				}}
			/>
		</div>

		<DefaultSimpleList
			bind:store={settingDocumentNameGeneratorStore}
			onAddRequest={() => {
				showCreateModal = true;
			}}
			onEditRequest={(item) => {
				targetSettingNameGenerator = item as SettingDocumentNameGenerator;
			}}
			onSelectionChanged={(item) => {
				if (showDetailOnClick) {
					targetSettingNameGenerator = item as SettingDocumentNameGenerator;
				} else {
					onSelectionChanged?.(item as SettingDocumentNameGenerator);
				}
			}}
			itemComponent={ListItemSettingDocumentNameGenerator}
		/>
	</div>

	{#if showCreateModal}
		<CreateSettingDocumentNameGenerator
			onModalClose={() => {
				showCreateModal = false;
			}}
			store={settingDocumentNameGeneratorStore}
		/>
	{/if}

	{#if targetSettingNameGenerator}
		<PatchSettingDocumentNameGenerator
			onModalClose={() => {
				targetSettingNameGenerator = undefined;
			}}
			store={settingDocumentNameGeneratorStore}
			targetItem={targetSettingNameGenerator}
		/>
	{/if}
</div>
